'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsOpen = undefined;

var _reselect = require('reselect');

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _getWidgetUiState = require('./getWidgetUiState');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getIsOpen = exports.getIsOpen = (0, _reselect.createSelector)([_getWidgetUiState.getWidgetUiState], (0, _getIn2.default)(['open']));


//////////////////
// WEBPACK FOOTER
// ./js/selectors/getIsOpen.js
// module id = 70
// module chunks = 2 3